module.exports = __webpack_public_path__ + "img/tutorial2.94c4de94.png";